<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page04"></a>
<a id="page05"></a>
<p class="dedicationText"><em class="italic">For two remarkable men,<br/> Daniel and Jono,<br/> from their proud and lucky mother</em></p>
<a id="page06"></a>
<a id="page07"></a>
<a id="page08"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded01.vue?536e1adc